module.exports = __webpack_public_path__ + "media/mypage/images/fa/7-de833c4e7d91381ffb66e675699f9076.jpg";